import {Base} from "@/api/Base"

export class MpfAdd extends Base {
    path = "mpf/add"
}